export const CARD_SECTION = {
  FULL_DEBT_SUM: 1
}
